import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import { MultiForm } from "../MultiForm";

export function UserButtons({ showSingleButton = false }) {
  const [form, setForm] = useState<"signup" | "login" | null>(null);

  const ModalComponent = (
    <Modal size="lg" isOpen={Boolean(form)} onClose={() => setForm(null)}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <MultiForm
          isSignUp={form === "signup"}
          onChange={(isSignUp) => setForm(isSignUp ? "signup" : "login")}
        />
      </ModalContent>
    </Modal>
  );

  return (
    <>
      {showSingleButton ? (
        <>
          <Button
            size="sm"
            display={["none", "flex"]}
            fontSize="md"
            colorScheme="gray"
            onClick={() => setForm("login")}
          >
            Log in
          </Button>
          {ModalComponent}{" "}
        </>
      ) : (
        <>
          <ButtonGroup size="sm">
            <Button
              display={["none", "flex"]}
              fontSize="md"
              variant="ghost"
              onClick={() => setForm("login")}
            >
              Log in
            </Button>
            <Button
              fontSize="md"
              colorScheme="gray"
              onClick={() => setForm("signup")}
            >
              Sign up
            </Button>
          </ButtonGroup>
          {ModalComponent}
        </>
      )}
    </>
  );
}
